export default "__VITE_ASSET__5e0800ef__"